import { render, staticRenderFns } from "./ViewPatientAppointmentDialog.vue?vue&type=template&id=f6f2ec6c&scoped=true"
import script from "./ViewPatientAppointmentDialog.vue?vue&type=script&lang=js"
export * from "./ViewPatientAppointmentDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewPatientAppointmentDialog.vue?vue&type=style&index=0&id=f6f2ec6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f2ec6c",
  null
  
)

export default component.exports